import {Exception} from "@/api/interfaces/exception.interface";

export class DpExceptions {
  constructor(
      public readonly exceptions: Exception[],
      public readonly request?: any,
      public readonly response?: any
  ) {}
}